import axios from "../axios";
import model from "../../model";

export const createUser = async (createUser) => {
    let userDTO = model.toUserDTO(createUser)
    let res = await axios.post(`/users`, userDTO)
    return model.fromUserDTO(res.data)
}

export const readUsers = async () => {
    let res = await axios.get(`/users`)
    return model.fromUsersDTO(res.data)
}

export const readUser = async (id) => {
    let res = await axios.get(`/users/${id}`)
    return model.fromUserDTO(res.data)
}

export const updateUser = async (id, updateUser) => {
    let userDTO = model.toUserDTO(updateUser)
    await axios.put(`/users/${id}`, userDTO)
    let res = await axios.get(`/users/${id}`)
    return model.fromUserDTO(res.data)
}

export const deleteUser = async (id) => {
    await axios.delete(`/users/${id}`)
    return {}
}

export const createWorkDay = async (id, createWorkDay) => {
    let workDayDTO = model.toWorkDayDTO(createWorkDay)
    let res = await axios.post(`/users/${id}/workDays`, workDayDTO)
    return model.fromWorkDaysDTO(res.data)
}

export const updateWorkDay = async (userId, workDayId, updateWorkDay) => {
    let workDayDTO = model.toWorkDayDTO(updateWorkDay)
    let res = await axios.put(`/users/${userId}/workDays/${workDayId}`, workDayDTO)
    return res
}

export const deleteWorkDay = async (userId, workDayId) => {
    let res = await axios.delete(`/users/${userId}/workDays/${workDayId}`)
    return res
}

export const readCurrentFlexTimeAccount = async (id) => {
    let res = await axios.get(`/users/${id}/currentFlexTimeAccount`)
    return res.data
}

export const readRemainingWorkLoadClosingDays = async (id) => {
    let res = await axios.get(`/users/${id}/remainingWorkLoadClosingDays`)
    return res.data
}

export const submitMonths = async (id, months) => {
    let res = await axios.post(`/users/${id}/submit`, months)
    return res
}

export const unsubmitMonths = async (id, months) => {
    let res = await axios.post(`/users/${id}/unsubmit`, months)
    return res
}
